import controller from '../field.controller';
import template from './textAreaField.html';

let component = {
  restrict: 'E',
  template,
  controller,
  controllerAs: 'vm',
  bindings: {
    fieldResponse: '<',
    onUpdate: '&',
  }
};

export default component;
